<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 11H17M17 11H21M17 11V19M2 3H8M8 3H14M8 3V19" stroke="white" stroke-width="2" stroke-linecap="round"/>
  </svg>
</template>

<script>

export default {
  name: 'addTextIcon',
  components: {
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>

</style>
